import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const HESTIA_CUSTOMERS_ROUTES = new Set(['brand.apps.customers'])

export const checkHestiaCustomersFeatureFlag: HermesGuardFn = async (to) => {
  if (!HESTIA_CUSTOMERS_ROUTES.has(to.name as string)) return undefined

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled('hermes.hestiaCustomers')) {
    return {
      name: 'brand.customers',
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
